import {

  GET_MERCHANT_LINK_PAYMENT_SUCCESS,
  GET_MERCHANT_LINK_PAYMENT_BY_GUID,
  GET_MERCHANT_LINK_PAYMENT_BY_GUID_SUCCESS,
  ADD_MERCHANT_LINK_PAYMENT_SUCCESS,
  UPDATE_MERCHANT_LINK_PAYMENT_SUCCESS,
  DELETE_MERCHANT_LINK_PAYMENT_SUCCESS,
  UPDATE_MERCHANT_LINK_PAYMENT_STATUS_SUCCESS,
  SHARE_MERCHANT_LINK_PAYMENT_SUCCESS,
  MERCHANT_LINK_PAYMENT_API_ERROR,
  GET_MERCHANT_LINK_PAYMENT_SPESIFIC_BY_KEY,
  GET_MERCHANT_LINK_PAYMENT_SPESIFIC_BY_KEY_SUCCESS,
  MERCHANT_LINK_DO_PAYMENT,
  MERCHANT_LINK_DO_PAYMENT_SUCCESS,
  MERCHANT_LINK_CHECK_BIN_CARD_NUMBER,
  MERCHANT_LINK_CHECK_BIN_CARD_NUMBER_SUCCESS,
  MERCHANT_LINK_CHECK_BIN_CARD_NUMBER_FAIL,
  MERCHANT_LINK_CLEAR_CHECK_BIN_ERROR
} from "./actionTypes"

const INIT_STATE = {
  recordList: [],
  record: {},
  error: null,
  checkBinCardRecord: {},
  checkBinError: null,
  waitingRecordListUpdate: false,
  linkPaymentByGuidLoading: false,
  linkPaymentDetailRecord: null,
}

const merchantLinkPayment = (state = INIT_STATE, action) => {
  switch (action.type) {

    case GET_MERCHANT_LINK_PAYMENT_SUCCESS:
      return {
        ...state,
        recordList: action.payload,
      }

    case GET_MERCHANT_LINK_PAYMENT_BY_GUID:
      return {
        ...state,
        linkPaymentByGuidLoading: true,
        linkPaymentDetailRecord: null,
      }

    case GET_MERCHANT_LINK_PAYMENT_BY_GUID_SUCCESS:
      return {
        ...state,
        linkPaymentByGuidLoading: false,
        linkPaymentDetailRecord: action.payload,
      }

    case GET_MERCHANT_LINK_PAYMENT_SPESIFIC_BY_KEY:
      return {
        ...state,
        loading: true,
      }

    case GET_MERCHANT_LINK_PAYMENT_SPESIFIC_BY_KEY_SUCCESS:
      return {
        ...state,
        record: action.payload,
        loading: false,
      }

    case ADD_MERCHANT_LINK_PAYMENT_SUCCESS:
      return {
        ...state,
        recordList: [...state.recordList, action.payload],
        waitingRecordListUpdate: !state.waitingRecordListUpdate,

      }
    case SHARE_MERCHANT_LINK_PAYMENT_SUCCESS:
    case UPDATE_MERCHANT_LINK_PAYMENT_SUCCESS:
      return {
        ...state,
        recordList: state.recordList.map(record =>
          record.guid.toString() === action.payload.guid.toString()
            ? { record, ...action.payload }
            : record
        ),
      }
    case DELETE_MERCHANT_LINK_PAYMENT_SUCCESS:
      return {
        ...state,
        recordList: state.recordList.filter(
          record => record.guid.toString() !== action.payload.toString()
        ),
      }
    case UPDATE_MERCHANT_LINK_PAYMENT_STATUS_SUCCESS:
      return {
        ...state,
        recordList: state.recordList.filter(
          record => record.guid.toString() !== action.payload.toString()
        ),
      }

    case MERCHANT_LINK_DO_PAYMENT:
      return {
        ...state,
        loading: true,
      }

    case MERCHANT_LINK_DO_PAYMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        record: action.payload,
      }

      case MERCHANT_LINK_CHECK_BIN_CARD_NUMBER:
        return {
          ...state,
          checkBinLoading: true,
          checkBinError: null,
        }
  
      case MERCHANT_LINK_CHECK_BIN_CARD_NUMBER_SUCCESS:
        return {
          ...state,
          checkBinLoading: false,
          checkBinCardRecord: action.payload,
          checkBinError: null,
        }

      case MERCHANT_LINK_CHECK_BIN_CARD_NUMBER_FAIL:
        return {
          ...state,
          checkBinLoading: false,
          checkBinCardRecord: {},
          checkBinError: action.payload,
        }

      case MERCHANT_LINK_CLEAR_CHECK_BIN_ERROR:
        return {
          ...state,
          checkBinError: null,
        }

    case MERCHANT_LINK_PAYMENT_API_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        checkBinLoading: false,
        linkPaymentByGuidLoading: false,
      }

    default:

      return state

  }
}

export default merchantLinkPayment